import { InventoryItem } from "@/components/Types";
import { LANGUAGES } from "@/lib/constants";
import { createSlice, PayloadAction } from "@reduxjs/toolkit";


export interface TutorialMessage {
    id: string;
    language: string;
    text?: string;
    fragmentId?: string;
    contextPath?: string[];
    modalId?: string;
    audioUrl?: string;
    priority?: number;
    
}

export interface TutorialState {
    messageQueue: TutorialMessage[];
    currentMessage: TutorialMessage | null;
    isPlaying: boolean;
    isVisible: boolean;
    dismissedMessages: string[]; // Track dismissed context paths
    speechRecordingInProgress?: boolean;
}

const initialState: TutorialState = {    
    messageQueue: [],
    currentMessage: null,
    isPlaying: false,
    isVisible: false,
    dismissedMessages: [],
    speechRecordingInProgress: false,
}

export const tutorialSlice = createSlice({
    name: 'tutorial',
    initialState,
    reducers: {
        queueMessage: (state, action: PayloadAction<TutorialMessage>) => {
            state.messageQueue.push(action.payload);
        },
        setMessageQueue: (state, action: PayloadAction<TutorialMessage[]>) => {
            state.messageQueue.length = 0;
            state.messageQueue.push(...action.payload);
        },
        dismissCurrent: (state) => {
            state.currentMessage = null;
        },
        takeNextMessage: (state) => {
            if (state.messageQueue.length > 0) {
                state.currentMessage = state.messageQueue[0];
                state.messageQueue = state.messageQueue.slice(1);
            } else {
                state.currentMessage = null;
            }
        },
        setIsPlaying: (state, action: PayloadAction<boolean>) => {
            state.isPlaying = action.payload;
        },
        setIsVisible: (state, action: PayloadAction<boolean>) => {
            state.isVisible = action.payload;
        },
        setDismissedMessages: (state, action: PayloadAction<string[]>) => {
            state.dismissedMessages = action.payload;
        },
        setSpeechRecordingInProgress: (state, action: PayloadAction<boolean>) => {
            state.speechRecordingInProgress = action.payload;
        },
    }
});

export const tutorialActions = {
    queueMessage: tutorialSlice.actions.queueMessage,
    setMessageQueue: tutorialSlice.actions.setMessageQueue,
    takeNextMessage: tutorialSlice.actions.takeNextMessage,
    dismissCurrent: tutorialSlice.actions.dismissCurrent,
    setIsPlaying: tutorialSlice.actions.setIsPlaying,
    setIsVisible: tutorialSlice.actions.setIsVisible,
    setDismissedMessages: tutorialSlice.actions.setDismissedMessages,
    setSpeechRecordingInProgress: tutorialSlice.actions.setSpeechRecordingInProgress,
};

export default tutorialSlice.reducer;